import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext,HamContext, LangContext, MenuContext, Nav_, logo, s3 } from 'monica-alexandria'
import { AuthContext } from '../../services/authentication/Guard'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import i18n from '../../localization/i18next'
import { checkPermissions } from '../../helpers/checkPermissions';
import store from '../../redux/store'
import { get_users_with_roles, save_preferences } from '../../services/api/Users'
import { get_company_departments } from '../../services/api/Company'
import { get_leave_requests } from '../../services/api/Leaves'
import { update_options_cookie } from '../../helpers/initMenuOptions'
import config from '../../config/index'
import { Navbar_Notifications_Slider } from './Navbar_Notifications_Slider'
import {
    filter_personal_leave_approval_notifications,
    leave_approval_notifications_event_name
} from '../../utils/leaves/leave_approvals'
import { read_current_user } from '../../utils/users/user_identity'


import clients from '../../config/index'
const authClient = process.env.REACT_APP_AUTH_CLIENT;
const client = process.env.REACT_APP_CLIENT;
const defaultAvatar = `${s3}doitforme/morning/app/dolores/DefaultAvatar.jpg`
const notificationRefreshMs = 30 * 1000

const Navbar_ = () => {
    const { t } = useTranslation();
    const [textCta, setTextCta] = useState('');
    const [hamState, setHamState] = useState(false);
    const [image, setImage] = useState(defaultAvatar)
    const { setActiveMenu } = useContext(MenuContext)
    const { setLanguage } = useContext(LangContext)
    const { theme, setTheme } = useContext(ThemeContext)
    const [approvalNotifications, setApprovalNotifications] = useState([])
    const [notificationsSlider, setNotificationsSlider] = useState(false)
    const [app, major, minor] = __APP_VERSION__.split('.').map(Number);

    const lang = i18n.language ? i18n.language : 'en';
    let navigate = useNavigate();
    
    
    const changeLanguage = (lang, userInitiated) => {

        if (auth?.authenticated && userInitiated) save_preferences();
        let path = window.location.pathname.split('/');
        path[1] = lang;
        let newPath = path.join('/');
        i18n.changeLanguage(lang);
        store.dispatch({type: "LANGUAGE_UPDATE", payload: lang})
        navigate(newPath);
        setLanguage(lang);
        setActiveMenu('Main');
    }

    const auth = useContext(AuthContext);
    const userId = store.getState()?.user?.user?.sub
    const currentUser = {
        ...(auth?.user || {}),
        ...read_current_user()
    }
    
    const permission = checkPermissions('Knight',auth?.user?.roles || [])
    const baronPermission = checkPermissions('Baron', auth?.user?.roles || [])
    const unreadNotificationsCount = approvalNotifications.length ? `${approvalNotifications.length}` : ''
    const notificationIdentityKey = [
        currentUser?.sub,
        currentUser?.id,
        currentUser?.email,
        currentUser?.username,
        auth?.user?.sub,
        auth?.user?.email
    ].filter(Boolean).join('|')

    const getTextCta = () => {
        
        if(!auth.authenticated){
            setTextCta('Become a doer')
        }
        else if (!permission){
            setTextCta('Manage subscriptions')
        }
        else if(permission){
            setTextCta('Admin')
        }
    }

    const navigateCta = () =>{
        if(!auth.authenticated){
           navigate(auth?.login())
        }
        else{
           navigate(`/${lang}/akihiko/dolores`)
        }
        // else if(permission){
        //    window.location.assign(`${clients[client]}/${lang}/akihiko/${client}`)
        // }
    }
    //admin -> akihiko
    //auth -> erised
    const logoCLick = () => {
       if(!auth.authenticated) { auth?.login() } else { window.location.assign(`${clients[authClient]}/${lang}`) }
    }

    const settingsClick = () => {
        window.location.assign(`${clients[authClient]}/${lang}/settings`)
    }

    const avatarClick = () => {
        window.location.assign(`${clients[authClient]}/${lang}`)
    }

    /* Read one backend response collection using the existing API response shape. */
    const read_collection = (response) => {
        return response?.data?.data || []
    }

    /* Load personal leave approvals this Baron can approve for his department. */
    const load_approval_notifications = async () => {
        if (!baronPermission) {
            setApprovalNotifications([])
            return
        }

        const [usersResponse, departmentsResponse, leaveRequestsResponse] = await Promise.all([
            get_users_with_roles(),
            get_company_departments(),
            get_leave_requests()
        ])
        const nextUsers = read_collection(usersResponse)
        const nextDepartments = read_collection(departmentsResponse)
        const nextLeaveRequests = read_collection(leaveRequestsResponse)

        setApprovalNotifications(filter_personal_leave_approval_notifications(
            nextLeaveRequests,
            nextUsers,
            nextDepartments,
            currentUser
        ))
    }

    /* Open the live approval notification slider from the Nav_ notification button. */
    const open_notifications_slider = () => {
        load_approval_notifications()
        setNotificationsSlider(true)
    }

    /* Close the approval notification slider without changing the pending requests. */
    const close_notifications_slider = () => {
        setNotificationsSlider(false)
    }

    /* Send the reviewer to the full Applications page for approve or decline actions. */
    const open_applications = () => {
        setNotificationsSlider(false)
        navigate(`/${lang}/akihiko/dolores/applications`)
    }


    useEffect(() => {
        const userId = store.getState()?.user?.user?.sub;
        store.dispatch({type: 'THEME_UPDATE', payload: theme})
        if ( theme != store.getState().user?.user?.preferences?.theme ) update_options_cookie(userId)
    },[theme])
 
    useEffect(()=> {
       getTextCta();
       const avatarUrl = `${s3}erisedev/${userId}/avatar.png`
       const avatarImage = new window.Image()

       avatarImage.onload = () => {
            setImage(avatarUrl)
       }

       avatarImage.onerror = () => {
            setImage(defaultAvatar)
       }

       avatarImage.src = avatarUrl
      },[])

    useEffect(() => {
        const sync_visible_notifications = () => {
            if (document.visibilityState === 'visible') {
                load_approval_notifications()
            }
        }
        const notificationsInterval = window.setInterval(load_approval_notifications, notificationRefreshMs)

        load_approval_notifications()
        window.addEventListener(leave_approval_notifications_event_name, load_approval_notifications)
        window.addEventListener('focus', load_approval_notifications)
        document.addEventListener('visibilitychange', sync_visible_notifications)

        return () => {
            window.clearInterval(notificationsInterval)
            window.removeEventListener(leave_approval_notifications_event_name, load_approval_notifications)
            window.removeEventListener('focus', load_approval_notifications)
            document.removeEventListener('visibilitychange', sync_visible_notifications)
        }
    }, [baronPermission, notificationIdentityKey])

    return (
        <HamContext.Provider value={{hamState, setHamState}}>        
            <>
                <Nav_
                    tool="Doitforme"
                    home
                    onHome ={() => navigate(`/${lang}/akihiko/dolores`)}
                    iconHome = {logo.dailyprofit[theme]}
                    textHome = {auth?.authenticated ? (t('Dashboard')): (t('Join'))}
                    minorV = {minor}
                    majorV = {major}
                    onClick_Logo = {logoCLick}
                    firstname_Account = {auth?.user?.firstname}
                    imgAlt_Account ="Text"
                    img_Account = {image}
                    onClick_Logout = {() => auth?.logout()}
                    onClick_Account = {avatarClick}
                    onClick_Cta = {navigateCta}
                    onClick_Login = {() =>  auth?.login(authClient, window.location.href)}
                    onClick_Settings_Main = {settingsClick}
                    onClick_Notifications = {open_notifications_slider}
                    unread_Notifications = {unreadNotificationsCount}
                    role={permission ? 'Admin' :auth?.authenticated ? 'Protected' : 'Unprotected'}
                    no_Cta={permission ? false : true}
                    onClick_Admin_Main = {()=> navigate(`/${lang}/akihiko/dolores`)}
                    text_Admin_Main = {t('Admin')}
                    onClick_Subscriptions_Main= {()=>window.location.assign(`${clients.griphook}/${lang}`)}
                    text_Subscriptions_Main={t("Subscriptions")}
                    text_Cta ={t(textCta)}
                    text_Login ={t("Join")}
                    text_Logout ={t("Logout")}
                    text_Settings_Main = {t("Settings")}
                    text_Theme_Main = {t("Theme")}
                    text_Title_Language = {t("Language")}
                    text_Title_Main = {t("Menu")}
                    text_Title_Region = {t("Region")}
                    onClick_English_Language = {() => changeLanguage('en', 'USER_INITIATED')}
                    onClick_German_Language = {() => changeLanguage('de', 'USER_INITIATED')}
                    onClick_Greek_Language = {() => changeLanguage('el', 'USER_INITIATED')}
                    onClick_Italian_Language= {() => changeLanguage('it', 'USER_INITIATED')}
                    text_Apps = {t("Apps")}
                    text_All_Title = {t("Doitforme applications")}
                    onClick_All_Dailyprofit = {() => window.location.assign(config.dailyprofit)}
                    onClick_All_Lois = {() => window.location.assign(config.lois)}
                    onClick_All_Whitecastle = {() => window.location.assign(config.whitecastle)}
                    onClick_All_Syrax = {() => window.location.assign(config.syrax)}
                />
                <Navbar_Notifications_Slider
                    open={notificationsSlider}
                    notifications={approvalNotifications}
                    onApplicationsClick={open_applications}
                    onClose={close_notifications_slider}
                />
            </>
        </HamContext.Provider>   
    )
}

export default Navbar_
